import { memo } from 'react';
import { CardProps } from '@src/components/side-bar-menu/worlds/types';
import styles from '../worlds-drawer.module.css';

export default memo(function Card({
  item,
  onLoadWorld,
  isSelected,
  isWorld,
}: CardProps) {
  const url = isWorld ? item.baseModelURL : item.assetURL;
  const thumbnail = isWorld ? item.thumbnail : item.previewImage;

  return (
    <div
      className={`${styles.worldCard} ${isSelected ? styles.selected : ''}`}
      onClick={() =>
        onLoadWorld(
          url!,
          item.name,
          isWorld ? 'SCENE' : item.modelType!,
          thumbnail!
        )
      }
    >
      <img src={thumbnail} className={styles.cardImage} alt={item.name} />
    </div>
  );
});
